<h4><span translate>Scegli la fascia oraria per l'aggiornamento della tua subscription</span>:</h4>
<ul>
  <li style="display: inline-block;">
      <mat-slide-toggle (change)="updateAnswerNew(0)" color="primary" #toggleElementMail>
      </mat-slide-toggle>
  </li>
  <li style="display: inline-block; margin-left: 2rem;">
      <label>9:00 - 9:15</label>
  </li>
</ul>
<ul>
  <li style="display: inline-block;">
      <mat-slide-toggle (change)="updateAnswerNew(1)" color="primary" #toggleElementMail>
      </mat-slide-toggle>
  </li>
  <li style="display: inline-block; margin-left: 2rem;">
      <label>12:00 - 12:15</label>
  </li>
</ul>
<ul>
  <li style="display: inline-block;">
      <mat-slide-toggle (change)="updateAnswerNew(2)" color="primary" #toggleElementMail>
      </mat-slide-toggle>
  </li>
  <li style="display: inline-block; margin-left: 2rem;">
      <label>17:00 - 17:15</label>
  </li>
</ul>
<mat-form-field appearance="outline">
  <mat-label translate>EDIT_ACCOUNTS.IPT_FLD_6</mat-label>
  <input matInput   name="Notes" />
</mat-form-field>
<div style="display: flex; justify-content: right">
  <button mat-flat-button color="primary" >
      <span translate>B_CANCEL</span>
  </button>
  <button mat-flat-button color="primary">
      <span translate>B_SAVE</span>
  </button>
</div>
